import {Link, Truncate} from '@primer/react'
import {useFragment} from 'react-relay/hooks'

import type {ReferencedEvent$key} from './__generated__/ReferencedEvent.graphql'
import {commitHovercardPath} from '@github-ui/paths'
import {ReferencedEventFragment} from './ReferencedEvent'

type ReferencedEventInnerProps = {
  queryRef: ReferencedEvent$key
}

export function ReferencedEventInner({queryRef}: ReferencedEventInnerProps): JSX.Element {
  const {commit} = useFragment(ReferencedEventFragment, queryRef)

  if (commit === null) {
    return <></>
  }

  const dataHovercardUrl = commitHovercardPath({
    owner: commit.repository.owner.login,
    repo: commit.repository.name,
    commitish: commit.abbreviatedOid,
  })

  return (
    <Truncate title={commit.message} sx={{maxWidth: 500}}>
      <Link
        href={commit.url}
        target="_blank"
        sx={{color: 'fg.muted', fontFamily: 'monospace'}}
        data-hovercard-url={dataHovercardUrl}
        muted
      >
        {commit.message}
      </Link>
    </Truncate>
  )
}

try{ ReferencedEventInner.displayName ||= 'ReferencedEventInner' } catch {}